import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Theme } from 'ui_system/theme';
import { logout } from 'data_system/token_auth/actions';

import Avatar from 'views/anyguide/resources/components/Avatar';
import { t } from 'services/translation';

import HeaderMobileDropdown from './HeaderMobileDropdown';
import { NavLink } from './NavLink';
import { PROFILE } from '../routes/routes';

// Re-export NavLink for backwards compatibility
export { NavLink } from './NavLink';

const Wrapper = styled.div`
  position: relative;
`;

const Container = styled.div`
  align-items: center;
  background-color: ${(props) =>
    props.headerColor ? props.headerColor : '#FFFFFF'};
  border-bottom: 1px solid ${Theme.colors.lightLine};
  display: flex;
  font-size: 14px;
  font-weight: 600;
  height: 80px;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;

  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    padding-left: 20px;
    padding-right: 40px;
  }
`;

const LogoSection = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 40%;
`;

const Logo = styled.img`
  height: 100%;
  max-height: 50px;
  max-width: 100%;
  width: auto;
`;

const Nav = styled.div`
  align-items: center;
  display: flex;
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : '0px'};
  width: 30%;
`;

const RightNavLinks = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: right;
  max-width: 270px;
  width: 100%;
`;

const BodyWrapper = styled.div`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  background: black;
  height: 100%;
  opacity: 0.5;
  position: fixed;
  width: 100%;
  z-index: 1;
`;

ReactDOM.createPortal(BodyWrapper, document.body);

const Header = ({ brand, resource, partner, ...restProps }) => {
  const dispatch = useDispatch();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { headerColor, logo, name, dynamicHeaderLinkColor, linkColor } = brand;
  const { supportLink } = partner;
  const showSupportLink = !!(supportLink && supportLink.length > 0);

  let leftNav = null;
  let rightNav = null;
  if (resource && resource.data) {
    const { firstName, lastName, initials, avatarUrl } =
      resource.data.attributes;

    leftNav = (
      <Nav>
        <Link to={PROFILE}>
          <Avatar
            imageUrl={avatarUrl}
            initials={initials}
            size={50}
            fontSize={18}
          />
        </Link>
        <Link to={PROFILE}>
          <NavLink marginLeft="8px" color={dynamicHeaderLinkColor} hideMobile>
            {firstName} {lastName}
          </NavLink>
        </Link>
      </Nav>
    );

    rightNav = (
      <Nav justifyContent="flex-end">
        <RightNavLinks>
          <Link to={PROFILE}>
            <NavLink hideMobile>{t('MY_PROFILE')}</NavLink>
          </Link>
          {showSupportLink && (
            <a target="_blank" rel="noopener noreferrer" href={supportLink}>
              <NavLink hideMobile>{t('SUPPORT')}</NavLink>
            </a>
          )}
          <NavLink hideMobile onClick={() => dispatch(logout)}>
            {t('LOG_OUT')}
          </NavLink>
          <NavLink hideDesktop onClick={() => setMobileNavOpen(!mobileNavOpen)}>
            <i className="af-three-bars" />
          </NavLink>
        </RightNavLinks>
      </Nav>
    );
  }

  return (
    <Wrapper>
      <Container headerColor={headerColor} className={restProps.className}>
        {leftNav || <div />}
        <LogoSection>
          <Link to="/">{logo ? <Logo src={logo} /> : <div>{name}</div>}</Link>
        </LogoSection>
        {rightNav || <div />}
      </Container>
      <BodyWrapper visible={mobileNavOpen} />
      <HeaderMobileDropdown
        open={mobileNavOpen}
        setOpen={setMobileNavOpen}
        onLinkClick={() => setMobileNavOpen(false)}
        onLogout={() => dispatch(logout)}
        showSupportLink={showSupportLink}
        supportLink={supportLink}
        linkColor={linkColor}
      />
    </Wrapper>
  );
};

export default Header;
